import { client } from "../utils/axios";

export type CloudinaryImage = {
  cldnImageID: number;
  cldnPublicID: string;
  cldnVersion: number;
  objectURL?: string;
};

const MEDIA_PROXY_URL = process.env.REACT_APP_MEDIA_PROXY_URL || "";

export function isCloudinaryImage(x: any): x is CloudinaryImage {
  return (
    x &&
    typeof x.cldnImageID === "number" &&
    typeof x.cldnPublicID === "string" &&
    typeof x.cldnVersion === "number"
  );
}

export function isCloudinaryImageArray(xs: unknown): xs is CloudinaryImage[] {
  return Array.isArray(xs) && xs.every((x) => isCloudinaryImage(x));
}

export type CloudinaryAudio = {
  cldnAudioID: number;
  cldnPublicID: string;
  cldnVersion: number;
  objectURL?: string;
};

export function isCloudinaryAudio(x: any): x is CloudinaryAudio {
  return (
    x &&
    typeof x.cldnAudioID === "number" &&
    typeof x.cldnPublicID === "string" &&
    typeof x.cldnVersion === "number"
  );
}

export const CLOUD_NAME = "phonim";
const maxWidth = 640;

// see https://cloudinary.com/documentation/image_transformations
export function getURL(image: CloudinaryImage) {
  if (image.objectURL && MEDIA_PROXY_URL) {
    return `${MEDIA_PROXY_URL}/insecure/rs:fit:${maxWidth}:0/plain/${image.objectURL}`;
  }
  const trans = `w_${maxWidth},f_auto`;
  return `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/${trans}/v${image.cldnVersion}/${image.cldnPublicID}.jpg`;
}

export async function uploadImage(file: File) {
  const c = await client();
  const form = new FormData();
  form.append("file", file);
  const res = await c.post("/media/image", form);
  const { data } = res;
  if (isCloudinaryImage(data)) {
    return data;
  }
  throw Error("invalid data: " + JSON.stringify(data));
}

export function getAudioURL(image: CloudinaryAudio, ext: string) {
  if (image.objectURL) {
    return image.objectURL;
  }
  return `https://res.cloudinary.com/${CLOUD_NAME}/video/upload/v${image.cldnVersion}/${image.cldnPublicID}.${ext}`;
}

export function videoSources(cldn: CloudinaryAudio, contentType?: string) {
  if (cldn.objectURL) {
    // GCS 公開 URL で直接再生 (実際の contentType を使用)
    return {
      sources: [
        {
          src: cldn.objectURL,
          type: contentType || "video/mp4",
        },
      ],
    };
  }
  // Cloudinary フォールバック (移行前の既存動画)
  const src = `https://res.cloudinary.com/${CLOUD_NAME}/video/upload/sp_hd/b_black,c_pad,ar_16:9/v${cldn.cldnVersion}/${cldn.cldnPublicID}.m3u8`;
  const poster = `https://res.cloudinary.com/${CLOUD_NAME}/video/upload/b_black,c_pad,w_854,h_480/v${cldn.cldnVersion}/${cldn.cldnPublicID}.jpg`;
  return {
    sources: [
      {
        src,
        type: "application/x-mpegURL",
      },
    ],
    poster,
  };
}
